import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import QRCode from 'qrcode';

import styles from './qrcode.module.scss';

/**
 * Generate a canvas QR code image from the provided code
 *
 * @link https://www.npmjs.com/package/qrcode
 * @param {Object} props
 */
const QRCodeImage = (props) => {
  const { className, code, imageClassName, options, ...rest } = props;
  const canvasRef = useRef();

  const defaults = { margin: 0, width: 600 };

  useEffect(() => {
    if (canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, code, {
        ...defaults,
        ...options,
      }).catch(console.error);
    }
  });

  return (
    <div className={classnames(className, styles.container)} {...rest}>
      <canvas
        className={classnames(imageClassName, styles.canvas, 'image')}
        ref={canvasRef}
      />
    </div>
  );
};

QRCodeImage.propTypes = {
  code: PropTypes.string.isRequired,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  codeClassName: PropTypes.string,
  options: PropTypes.object,
};

export default QRCodeImage;
